import { afterNextPaint } from '@helpers/after-next-paint';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { scroller } from 'react-scroll';
import type { Decorated } from 'types/vendor';
import { NavBar } from './components/NavBar';
import { NavSections } from './components/NavSections';
import type { NavItemElements } from './types';

interface Props {
	children: NavItemElements;
	vendor: Decorated;
}

export const Nav = ({ children, vendor }: Props) => {
	const { hash } = useLocation();

	useEffect(() => {
		if (!hash.startsWith('#nav')) return;

		const targetId = hash.slice(1);
		let observer: ResizeObserver | null = null;
		let disconnectTimer: ReturnType<typeof setTimeout> | null = null;

		afterNextPaint(() => {
			scroller.scrollTo(targetId, { smooth: true, offset: -85 });

			const el = document.getElementById(targetId);
			if (!el) return;

			observer = new ResizeObserver(() => {
				const displacement = el.getBoundingClientRect().top - 85;
				if (displacement > 10) {
					window.scrollBy(0, displacement);
				}
			});

			observer.observe(document.body);
			disconnectTimer = setTimeout(() => observer?.disconnect(), 3000);
		});

		return () => {
			observer?.disconnect();
			if (disconnectTimer) clearTimeout(disconnectTimer);
		};
	}, [hash]);

	return (
		<>
			<div>
				<NavBar>{children}</NavBar>
				<NavSections vendor={vendor}>{children}</NavSections>
			</div>
		</>
	);
};
